module.exports = __webpack_public_path__ + "static/img/0001.10d780bc.png";